/* MOJITO: free gift set cart line layout (ALO style).
   For the gift set line ONLY (variant 47084366201081): moves the title and
   the FREE price into one row across the top, with the photo + description
   underneath. Styles live in assets/mojito-cart-head.css. Works with both
   versions of snippets/mojito-free-gift*.liquid.
   Also copies the cart item count into data-count on the drawer title's
   count span, so the CSS can show it as a number in a black circle.
   Also puts "People also bought" on the /cart PAGE (see mountCartPageUpsell). */
(function () {
  'use strict';
  var GIFT_ID = '47084366201081';
  var queued = false;

  /* "People also bought" on the cart page. The drawer gets it from
     snippets/cart-drawer.liquid, but that snippet isn't rendered on /cart.
     Here we add the same host under the product list and load the same
     controller (assets/mojito-cart-upsell.js + .css), which fills it. */
  var upsellLoaded = false;
  function mountCartPageUpsell() {
    var page = document.querySelector('.cart[data-cart-page]');
    if (!page) return;
    var wrapper = page.querySelector('.cart__items__wrapper');
    if (!wrapper) return;
    if (!page.querySelector('[data-mojito-cart-upsell]')) {
      var host = document.createElement('div');
      host.className = 'mojito-pab-host mojito-pab-host--page is-empty';
      host.setAttribute('data-mojito-cart-upsell', '');
      host.innerHTML = '<div data-cart-upsell-content></div>';
      wrapper.parentNode.insertBefore(host, wrapper.nextSibling);
    }
    if (upsellLoaded) return;
    upsellLoaded = true;
    var src = (window.MOJITO_UPSELL_JS || '');
    var css = (window.MOJITO_UPSELL_CSS || '');
    var me = document.currentScript || document.querySelector('script[src*="mojito-gift-line"]');
    var base = me && me.src ? me.src.split('mojito-gift-line.js')[0] : '';
    if (!document.querySelector('script[src*="mojito-cart-upsell.js"]')) {
      var s = document.createElement('script');
      s.src = src || (base + 'mojito-cart-upsell.js');
      s.defer = true;
      document.head.appendChild(s);
    }
    if (!document.querySelector('link[href*="mojito-cart-upsell.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = css || (base + 'mojito-cart-upsell.css');
      document.head.appendChild(l);
    }
  }

  function fix() {
    queued = false;
    document.querySelectorAll('.cart__item').forEach(function (item) {
      if (item.querySelector('.mojito-gift-head')) return;
      if (!item.querySelector('.cart__item__image a[href*="' + GIFT_ID + '"]')) return;
      var title = item.querySelector('.cart__item__title');
      var price = item.querySelector('.cart__item__price');
      if (!title || !price) return;
      var head = document.createElement('div');
      head.className = 'mojito-gift-head';
      head.appendChild(title);
      head.appendChild(price);
      item.insertBefore(head, item.firstChild);
      item.classList.add('has-gift-head');
    });

    // "2 items" -> data-count="2" for the round count badge.
    document.querySelectorAll('[data-cart-items-qty]').forEach(function (el) {
      var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      var v = isNaN(n) ? '' : String(n);
      if (el.getAttribute('data-count') !== v) el.setAttribute('data-count', v);
    });

    mountCartPageUpsell();
  }

  // The theme re-renders the drawer / cart on every change.
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(fix);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();
